import * as React from 'react'

import { Box, Button, Text } from '@factorialco/deprecated-design-system'

import Loading from 'modules/core/components/Loading'
import { Panes } from 'modules/core/components/Panes'
import PanesHeader from 'modules/core/components/PanesHeader'
import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import schemas from 'modules/custom_resources/store/collections/customResources/schemas'
import Schema from 'modules/custom_resources/store/models/customResources/Schema'

const GrowthPlansBundleSettings = () => {
  const { navigation } = useNavigation()

  const schema = schemas.find({
    name: Schema.SCHEMA_NAMES.growth_plans,
  })

  const { loading } = useAsyncData(
    () =>
      schemas.fetch({
        data: {
          topic_names: [Schema.TOPIC_NAMES.performance],
        },
      }),
    []
  )

  if (loading) return <Loading />

  return (
    <Panes direction="horizontal-2-cols-left-1-third" type="naked">
      <Box padding="s48">
        <PanesHeader
          description={i18n.t('app_store_v2.apps.growth_plans_custom_table.settings.description')}
          illustration="performance_management"
          line={false}
          title={i18n.t('app_store_v2.apps.growth_plans_custom_table.settings.title')}
        />
      </Box>
      <Box padding="s48">
        <Box
          background="grey200"
          borderRadius={{
            all: 'abs008',
          }}
          gap="s16"
          padding="s24"
          width="full"
        >
          <Text.Normal>
            {i18n.t('app_store_v2.apps.growth_plans_custom_table.settings.content')}
          </Text.Normal>
          <Button.Router
            to={navigation.settings.customizations.customTablesId.fullPath({
              id: schema?.attributes.id,
            })}
            type="secondary"
          >
            {i18n.t('app_store_v2.apps.growth_plans_custom_table.settings.new_button')}
          </Button.Router>
        </Box>
      </Box>
    </Panes>
  )
}

export default GrowthPlansBundleSettings
